import { withStyles } from "@material-ui/core/styles";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import CancelIcon from "@mui/icons-material/Cancel";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import Action from "components/ActionPopOver";
import Loader from "components/loader/Loader";
import React from 'react';
import { recurringValues } from "./taskAutomation";
import { fontConfig } from "theme/fontConfig";

const TableCellBody = withStyles((theme) => ({
  root: {
    height: "65px",
    padding: "0px 20px",
    fontFamily: fontConfig.GeneralTableCellBodyFont.family,
    fontSize: "12px",
    color: "#4F4F4F",
  },
}))(TableCell);

const displayGetInTouch = (row) => {
  const {when, unit, after} = row;
  if(when === 0 || !when ) return "On the day";
  const addSIfMoreThanOne = when > 1 ? "s" : "";
  return `${when} ${unit?.toLowerCase()}${addSIfMoreThanOne} ${after === 1 ? "after" : "before"}`
}

const TaskAutomationTableBody = ({loading,tasksList,onDeleteTask,openCreateTrigger}) => {
  return (
    <TableBody
      className="tran-table-body-schedules"
      style={{
      }}
    >
      {loading ? (
          <TableRow>
            <TableCell colSpan={10} align="center">
              <div
                className="user__loader"
                style={{ height: "320px" }}
              >
                <Loader />
              </div>
            </TableCell>
          </TableRow>
        ) : tasksList?.length === 0 ? (
          <TableRow>
            <TableCell colSpan={10} align="center">
              <h6 style={{ height: "320px", marginTop: "100px" }}>
                No Data Found
              </h6>
            </TableCell>
          </TableRow>
        ) : (
        tasksList?.map((row, i) => (
          <>
            <TableRow align="center" style={{}}>
              <TableCellBody component="th" scope="row">
                <div className="table-row">
                  {row?.name}
                </div>
              </TableCellBody>
              <TableCellBody align="left">{displayGetInTouch(row)}</TableCellBody>
              <TableCellBody align="left"> {recurringValues[row?.recurring]}</TableCellBody>
              <TableCellBody align="left" className="images-blocks">
                {row?.actionType}
              </TableCellBody>

              <TableCellBody align="left" className="images-blocks">
                {row?.clergyType}
              </TableCellBody>
              <TableCellBody align="left" className="images-blocks">
                {row?.active1 ? (
                  <CheckCircleIcon color="primary" />
                ) : (
                  <CancelIcon color="primary" />
                )}
              </TableCellBody>

              <TableCellBody className="sticky-body-column">
                <div
                  style={{
                    cursor: "pointer",
                    paddingleft: "0px",
                    zIndex: 1000,
                  }}
                >
                  <Action
                    action='class'
                    style={{ width: '16px' }}
                    onEditViewClick={() => openCreateTrigger(row)}
                    onClassDeleteClick={() => onDeleteTask(row)}
                  />
                </div>
              </TableCellBody>
            </TableRow>
          </>
        )
      ))}
    </TableBody>
  )
}

export default TaskAutomationTableBody